import { Component, OnInit, OnDestroy } from "@angular/core";
import { VariablePayReportsService } from "../services/variable-pay-reports.service";
import { SettingsService } from "../services/settings.service";
import { environment } from "../../environments/environment";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs/Subject";
import { Angular2Csv } from "angular2-csv/Angular2-csv";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

@Component({
  selector: "app-variable-pay-report",
  templateUrl: "./variable-pay-report.component.html",
  styleUrls: ["./variable-pay-report.component.css"],
})
export class VariablePayReportComponent implements OnInit, OnDestroy {
  headerList: string[] = [
    "Emp ID",
    "Name",
    "Joining Date",
    "Assessment Year",
    "Duration",
    "AVP",
    "Rating",
    "QVP",
  ];
  assessmentYears = [];
  duration = [];
  userAccounts = [];
  assessmentYearsFilter = "all";
  durationFilter = "all";
  userAccountsFilter = "all";
  searchAccount = "";
  reportsColl: any = [];
  unSub: Subject<void> = new Subject<void>();

  constructor(
    private variablePayReportsService: VariablePayReportsService,
    private settingsService: SettingsService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit() {
    this.getAccountsList();
    this.getAssessmentYearsList();
    this.getSettings();
  }

  ngOnDestroy() {
    this.unSub.next();
    this.unSub.complete();
  }

  /**
   * @description
   * Method to get accounts list
   */
  getAccountsList() {
    this.spinnerService.show();
    this.variablePayReportsService
      .getAccountsList()
      .pipe(takeUntil(this.unSub))
      .subscribe((res) => {
        this.spinnerService.hide();
        if (res.body["success"]) {
          this.userAccounts = res.body["result"].accounts;
        }
      });
  }

  /**
   * @description
   * Method to get assessment years list
   */
  getAssessmentYearsList() {
    this.spinnerService.show();
    this.variablePayReportsService
      .getAssessmentYearsList()
      .pipe(takeUntil(this.unSub))
      .subscribe((res) => {
        this.spinnerService.hide();
        if (res.body["success"]) {
          this.assessmentYears = res.body["result"];
          for (let year of this.assessmentYears) {
            if (year.is_current_year) {
              this.assessmentYearsFilter = year.assessment_year;
              this.getVariablePayReports();
            }
          }
        }
      });
  }

  getSettings() {
    this.spinnerService.show();
    this.settingsService
      .getSettings()
      .pipe(takeUntil(this.unSub))
      .subscribe((data) => {
        this.spinnerService.hide();
        if (data.body["success"]) {
          switch (data.body["result"].assessment_duration) {
            case "monthly":
              this.duration = environment.Month;
              break;
            case "quarterly":
              this.duration = environment.Quarters;
              break;
            case "half_yearly":
              this.duration = environment.Half_yearly;
              break;
            case "yearly":
              this.duration = environment.Yearly;
              break;
          }
        }
      });
  }

  /**
   * @description
   * Method to get variable pay lists
   */
  getVariablePayReports() {
    this.spinnerService.show();
    let params = {};
    if (this.userAccountsFilter && this.userAccountsFilter !== "all") {
      params["account_id"] = Number(this.userAccountsFilter);
    }
    if (this.assessmentYearsFilter && this.assessmentYearsFilter !== "all") {
      params["assessment_year"] = this.assessmentYearsFilter;
    }
    if (this.durationFilter && this.durationFilter !== "all") {
      params["duration"] = this.durationFilter;
    }
    if (this.searchAccount) {
      params["search"] = this.searchAccount;
    }
    this.variablePayReportsService
      .getVariablePayReports(params)
      .pipe(takeUntil(this.unSub))
      .subscribe((res) => {
        this.spinnerService.hide();
        if (res.body["success"]) {
          this.reportsColl = res.body["result"];
        }
      });
  }

  /**
   * @description
   * Method to export report to csv file
   */
  exportReport() {
    let reportData = [];
    for (let data of this.reportsColl) {
      const row = {
        emp_id: data.account.emp_id,
        name: data.account.name,
        joining_date: data.account.joining_date,
        year: data.assessment_year,
        duration: data.duration,
        a_vp: data.actual_vp,
        rating: data.rating,
        q_vp: data.final_vp,
      };
      reportData.push(row);
    }

    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      headers: this.headerList,
    };
    new Angular2Csv(reportData, "Variable Pay Report", options);
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/variable-pay-report/variable-pay-report.component.ts